<template>
  <div   class="app-main-container">
    <!-- <transition mode="out-in" name="fade-transform">  </transition> -->
    <router-view :key="key" class="app-main-height" />
   
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
 

  export default {
    name: 'VabAppMain',
    data() {
      return {
        show: false,
        fullYear: new Date().getFullYear(), 
        routerView: true, 
      }
    },
    computed: {
      ...mapGetters({
        visitedRoutes: 'tabsBar/visitedRoutes', 
      }), 
      key() {
        return this.$route.path
      },
    },
    watch: {
      $route: {
        handler(route) {
          if ('mobile' === this.device) this.foldSideBar()
        },
        immediate: true,
      },
    },
    created() {
      //重载所有路由
      // this.$baseEventBus.$on('reload-router-view', () => {
      //   this.routerView = false
      //   this.$nextTick(() => {
      //     this.routerView = true
      //   })
      // })
    },
    mounted() {},
    methods: {
      ...mapActions({
        foldSideBar: 'settings/foldSideBar',
      }),
    },
  }
</script>

<style lang="scss" scoped>
  .app-main-container {
    position: relative;
    width: 100%;
    // overflow: hidden;
    .vab-keel {
      margin: 10px;
    }
    .app-main-height {
      min-height: 100vh;
    }

    .footer-copyright {
      min-height: 55px;
      line-height: 55px;
      color: rgba(0, 0, 0, 0.45);
      text-align: center;
      // border-top: 1px dashed $base-border-color;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?0a6c1a88